import { use_slice_ui } from '@/hooks/store/use_slices';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';
import { ENUM__position_9, ENUM_UTILS__position_9 } from '@shared/enums/ENUM__position_9';
import { BUTTON_GRID2D_IMAGE__collection_image_add } from '../_buttons/BUTTON_GRID2D_IMAGE__collection_image_add';
import { BUTTON_GRID2D_IMAGE__collection_image_delete } from '../_buttons/BUTTON_GRID2D_IMAGE__collection_image_delete';
import { BUTTON_GRID2D_IMAGE__consume_content } from '../_buttons/BUTTON_GRID2D_IMAGE__consume_content';
import { BUTTON_GRID2D_IMAGE__copy_to_clipboard } from '../_buttons/BUTTON_GRID2D_IMAGE__copy_to_clipboard';
import { BUTTON_GRID2D_IMAGE__create_child_generation } from '../_buttons/BUTTON_GRID2D_IMAGE__create_child_generation';
import { BUTTON_GRID2D_IMAGE__download } from '../_buttons/BUTTON_GRID2D_IMAGE__download';
import { BUTTON_GRID2D_IMAGE__use_grid2d_dimensions } from '../_buttons/BUTTON_GRID2D_IMAGE__use_grid2d_dimensions';
import { ButtonGrid2dImageImageToTextCreate } from '../_buttons/ButtonGrid2dImageImageToTextCreate';
import { ButtonGrid2dImageImageToTextShow } from '../_buttons/ButtonGrid2dImageImageToTextShow';

interface PROPS {
  cell: DTO__grid2d_cell;
  entity: DTO__entity_with_grid2d;
}

export function GRID2D_CELL_OVERLAY__buttons({ cell, entity }: PROPS) {
  let { image } = cell;

  /*
   * STORE
   */
  const { global__is_shift_pressed } = use_slice_ui(['global__is_shift_pressed']);

  /*
   * RENDERS
   */
  function render_button_top_right() {
    let out = <></>;

    let wrapper_class_name = `absolute ${ENUM_UTILS__position_9.to_css_1(ENUM__position_9.TOP_RIGHT)} pointer-events-auto`;

    let button_props = { ...{ image, entity, wrapper_class_name, cell } };

    if (entity.type == ENUM__workspace_entity.ENTITY_GENERATION) {
      assert_instanceof(cell, DTO__grid2d_cell_generation);
      out = global__is_shift_pressed ? (
        <BUTTON_GRID2D_IMAGE__create_child_generation {...button_props} {...{ cell }} />
      ) : (
        <BUTTON_GRID2D_IMAGE__use_grid2d_dimensions {...button_props} {...{ cell }} />
      );
    }

    return out;
  }
  function render_button_bottom_left() {
    let out = <></>;

    let wrapper_class_name = `absolute ${ENUM_UTILS__position_9.to_css_1(ENUM__position_9.BOTTOM_LEFT)} pointer-events-auto`;

    let button_props = { ...{ image, entity, wrapper_class_name } };

    if (global__is_shift_pressed) {
      out = <BUTTON_GRID2D_IMAGE__copy_to_clipboard {...button_props} />;
    } else {
      out = <BUTTON_GRID2D_IMAGE__download {...button_props} />;
    }

    return out;
  }

  /*
   * METHODS
   */

  return (
    <div className="absolute inset-0 pointer-events-none">
      <BUTTON_GRID2D_IMAGE__consume_content
        wrapper_class_name={`absolute ${ENUM_UTILS__position_9.to_css_1(ENUM__position_9.BOTTOM_RIGHT)} pointer-events-auto`}
        {...{ entity, cell }}
      />

      <BUTTON_GRID2D_IMAGE__collection_image_add
        wrapper_class_name={`absolute ${ENUM_UTILS__position_9.to_css_1(ENUM__position_9.TOP_LEFT)} pointer-events-auto`}
        {...{ entity, cell }}
      />
      <BUTTON_GRID2D_IMAGE__collection_image_delete
        wrapper_class_name={`absolute ${ENUM_UTILS__position_9.to_css_1(ENUM__position_9.TOP_LEFT)} pointer-events-auto`}
        {...{ entity, cell }}
      />

      {render_button_top_right()}

      <ButtonGrid2dImageImageToTextShow wrapper_class_name="absolute bottom-1 left-1/2 transform -translate-x-1/2 pointer-events-auto" {...{ entity, image }} />

      <ButtonGrid2dImageImageToTextCreate
        wrapper_class_name="absolute bottom-1 left-1/2 transform -translate-x-1/2 pointer-events-auto"
        {...{ entity, image }}
      />

      {render_button_bottom_left()}
    </div>
  );
}
